import React from "react";
import myimg from "../../../assets/images/testing1.png";
import {Box, IconButton, Typography} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import ExtensionIcon from '@mui/icons-material/Extension';
import ArticleIcon from '@mui/icons-material/Article';

const ImageMessage = ({ url ,size, extention}) => {
  function getDocName(url){
    let fileName = url ? url.split('/').pop() : "";
    return fileName
  }
  
  return (
    <Box
      sx={{
        // minHeight: "100px",
        // maxWidth: "300px",
        borderRadius: ".25rem",
        overflow: "hidden",
      }}
    >
      <Box className="attachment-blk" component={'div'}>
      <Box className="left" component={'div'}>
      <Box className="chat-media-box">
      <img
      className="d-block m-auto"
        srcSet={url}
        src={url}
        alt={"Image"}
        loading="lazy"
      />
      </Box>

        <Box>
          <Box className="chat-doc-info">{getDocName(url)}</Box>
          <Box>
              <Typography component={'span'} className="note-text"><ExtensionIcon className="icon" /> {extention?extention:'Unknown'}</Typography>
              <Typography component={'span'} className="note-text"><ArticleIcon className="icon" /> {size}</Typography>
            </Box>
        </Box>
      </Box>
      </Box>

    </Box>
  );
};

export default ImageMessage;
